import * as Sentry from '@sentry/react';

import { env } from '@/app/config/env';

/**
 * Error reporting only, on the same project and release scheme as the legacy
 * portal. No tracing integration is added, so no sentry-trace or baggage
 * headers reach the API and the backend CORS allowlist needs no change; no
 * session replay, which would record balances and addresses.
 */
export const initSentry = (): void => {
  if (!env.sentryDsn) return;

  Sentry.init({
    dsn: env.sentryDsn,
    environment: env.sentryEnvironment,
    release: `trini-portal@${__APP_VERSION__}`,
    sendDefaultPii: false,
    // Request breadcrumbs keep the path but drop query strings (emails, ids).
    beforeBreadcrumb: (breadcrumb) => {
      if ((breadcrumb.category === 'xhr' || breadcrumb.category === 'fetch') && typeof breadcrumb.data?.url === 'string') {
        breadcrumb.data.url = breadcrumb.data.url.split('?')[0];
      }
      return breadcrumb;
    },
  });
};
